module.exports = __webpack_public_path__ + "static/media/1.11.517886e4.png";